

const IconArowRight = () => (
<svg width="4" height="6" viewBox="0 0 4 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.705535 0.972625C0.868253 0.809906 1.13207 0.809906 1.29479 0.972625L3.29479 2.97262C3.45751 3.13534 3.45751 3.39916 3.29479 3.56188L1.29479 5.56188C1.13207 5.7246 0.868253 5.7246 0.705535 5.56188C0.542816 5.39916 0.542816 5.13534 0.705535 4.97262L2.41091 3.26725L0.705535 1.56188C0.542816 1.39916 0.542816 1.13534 0.705535 0.972625Z" fill="#FBFBFB"/>
</svg>

);
export default IconArowRight;